<template>
  <div class="video-card" style="cursor:pointer" @mouseover="thumbnailHeight"> 
    <div
      class="video-thumbnail rounded d-flex align-items-center shadow-sm"
      ref="thumbnail"
       @click="onShowPreview"
    >
      <img
          v-if="thumbnail !== null"
          :src="thumbnail"
          alt=""
          class="rounded img-fluid"
          height="100%"
          width="100%"
      />
      <img
          v-else
          src='../assets/images/video-placeholder.png'
          alt=""
          class="rounded img-fluid"
          height="100%"
          width="100%"
      />


      <div v-if="duration" class="video-duration">
        {{ duration | videoDuration }}
      </div>
      <div v-if="workoutType" class="workout-type">
        {{ workoutType.type_name }}
      </div>
    </div>

    <div>
      <div class="flex-container">
        <div class="video-title">
          <!-- <h5 class="font-16 line-height-24 mt-2 title-line-limit ml-2">
            {{ title }}
          </h5> -->
        <div
            v-b-tooltip.hover
            :title="title"
            @click="onShowPreview"
            boundary-padding="2"
            class="pt-2 d-block ef-cursor-pointer workout-link"
        >
          <b class="title-line-limit" :class="{'notranslate' : !needTranslation}">{{ title }}</b>
        </div>
        </div>
        <div class="btn" v-if="enablePinFeature">
          <button class="bookmark-btn" v-if="!featured" @click="pinVideo(id)">
            <b-icon icon="bookmark"></b-icon>
          </button>
          <button class="bookmark-btn" v-if="featured" @click="unPinVideo(id)">
            <b-icon icon="bookmark-fill"></b-icon>
          </button>
        </div>
      </div>
      <!-- <b>Exercise</b> -->
    </div>

    <label
      class="color-primary border-green px-2 px-lg-3 font-weight-500 rounded m-0 mr-1 mr-lg-2 ef-cursor-pointer ml-1"
      v-for="(category, idx) in categories"
       @click="onShowPreview"
      :key="idx"
      >{{ category.WorkoutCategory.name }}
    </label>

    <PreviewVideo v-if="showPreview && thumbnail" :thumbnail="thumbnail" :tenant-name="tenantName" :url="goToVideo()" @cancel="showPreview=false"
    :title="title" :description="description" :video-id="id" :embed-id="embedId"
    
    ></PreviewVideo>
  </div>
</template>

<script>
import PreviewVideo from "@/module_user/components/Discover/PreviewVideoV2.vue";
import api from "../api.js";
export default {
  data() {
    return {
      showPreview: false
    }
  },
  props: {
    id: { type: Number | String, default: null },
    title: { type: String, default: null },
    description: { type: String, default: null },
    thumbnail: { type: String, default: null },
    duration: { type: Number | String, default: null },
    tenantName: { type: String, default: 'tenantName' },
    categories: { type: Array, default: null },
    intensity: { type: Number | String, default: null },
    featured: { type: Boolean, default: false },
    enablePinFeature: { type: Boolean, default: true },
    workoutType : {type : Object, default : null},
    embedId : {type : String , default : null},
    needTranslation : {type : Boolean, default : true}
  },
  methods: {
    thumbnailHeight() {
      this.$emit("thumbnailHeight", this.$refs.thumbnail.clientHeight);
    },
    goToVideo() {
      const currentPath = encodeURIComponent(this.$route.fullPath);
      let query = new URLSearchParams();
      query.set('returnToOnCancel', currentPath);
      query.set('id', this.id);
      const workoutTypeId = this.workoutType?.workout_type_id;
      if (workoutTypeId === 4) {
        query.set('duration', this.duration);
        query.set('sets', 1);
        return `/workout/rep?${query.toString()}`;
      } else if (workoutTypeId === 5) {
        query.set('duration', this.duration);
        query.set('sets', 1);
        return `/workout/hold-rep?${query.toString()}`;
      }
      return `/workout/${(this.tenantName || 'tenantName').replaceAll(/\s/g, "")}?${query.toString()}`;
    },
    onShowPreview() {
      this.showPreview = true;
    },
    getWorkoutIntensity(intensity) {
      if (!isNaN(+intensity) && +intensity <= 4.5) {
        return "Beginner";
      } else if (!isNaN(+intensity) && +intensity <= 7.5 && +intensity >= 5) {
        return "Intermediate";
      } else if (!isNaN(+intensity) && +intensity >= 8) {
        return "Advanced";
      } else {
        return "";
      }
    },
    getSimilargetCategoriesVideos(catId) {
      this.$router.push(`/categories/${catId}`);
    },

    // Pin Un-Pin Videos (Featured Videos)
    async pinVideo(id) {
      let requestData = {
        video_id: id,
      };
      let pinned = await api.pinVideo(requestData);
      if (pinned.code === 202) {
        this.$bvToast.toast(`${pinned.message}`, { variant: "danger" });
      } else if (pinned.code === 200) {
        this.$bvToast.toast(`${pinned.message}`, { variant: "success" });
        this.$emit("onPinSuccess", id, true);
      } else {
        this.$bvToast.toast(`Error`, { variant: "success" });
      }
    },
    async unPinVideo(id) {
      console.log("called unpin");
      const unPinned = await api.unPinVideo(id);
      if (unPinned.status === 200) {
        this.$emit("onPinSuccess", id, false);
      }
    }
  },
  filters: {
    videoDuration: function(time) {
      // Hours, minutes and seconds
      const hrs = ~~(time / 3600);
      const mins = ~~((time % 3600) / 60);
      const secs = ~~time % 60;

      // Output like "01:01" or "04:03:59" or "123:03:59"
      let ret = "";
      if (hrs > 0) {
        ret += "" + (hrs > 9 ? hrs : "0" + hrs) + ":";
      }
      ret += "" + (mins > 9 ? mins : "0" + mins) + ":";
      ret += "" + (secs > 9 ? secs : "0" + secs);
      return ret;
    },
  },
  components: {
    PreviewVideo,
  },
};
</script>

<style lang="scss" scoped>
.title-line-limit {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.margin-t{
  margin-top: 2rem;
}

.title-box-container {
  float: left;
}

.border-green {
  border: 1px solid;
  width: auto;
  border-color: #73bc44;
  font-size: 12px;
}
.video-thumbnail {
  cursor: pointer;
  position: relative;
  left: 0;
  top: 0;
  overflow: hidden;
  // width: 100%;
  // width: 500px;
  // height: 300px;
  aspect-ratio: 1.79; // width/height : 325/183
}
.video-duration {
  position: absolute;
  width: fit-content;
  right: 9px;
  bottom: 9px;
  text-align: center;
  color: #ffffff;
  background-color: #000000c9;
  border-radius: 2px;
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  padding: 0 5px;
}

.workout-type{
  position: absolute;
  width: fit-content;
  top: 9px;
  left: 9px;
  text-align: center;
  color: black;
  background-color: white;
  border-radius: 2px;
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  margin: 0 8px;
}

@media screen and (max-width: 768px) {
  .border-green {
    font-size: 10px;
  }
}

.bookmark-btn {
  border: 0px white;
}

.title-box-container {
  width: 100%;
  background-color: #ffffff;
  column-count: 2;
  column-gap: 50%;
}

.flex-container {
  display: flex;
}

.workout-link {
  text-decoration: none;
  color: black;
}
</style>
